import { Icon } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftPagination from "components/SoftPagination";
import PropTypes from "prop-types";

function Pagination({ maxPages, currentPage, onPageChange }) {
    let pagination = generatePageItems(maxPages, currentPage);
    return <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3} alignSelf="center">
        <SoftPagination>
            <SoftPagination item key={'pagination_prev'} onClick={() => (currentPage != 1) ? onPageChange(currentPage - 1) : {}} disabled={currentPage === 1 ?? false}>
                <Icon>keyboard_arrow_left</Icon>
            </SoftPagination>
            {
                pagination.map((singlePage) => {
                    const pageNumberText = (singlePage === 'prev-more' || singlePage === 'next-more') ? singlePage : singlePage + 1;
                    if (currentPage == pageNumberText) {
                        return <SoftPagination item key={'pagination_' + pageNumberText} active>{pageNumberText}</SoftPagination>;
                    }
                    if (pageNumberText === 'prev-more' || pageNumberText === 'next-more') {
                        return <SoftPagination item key={'pagination_' + pageNumberText}>...</SoftPagination>;
                    }
                    return <SoftPagination item key={'pagination_' + pageNumberText} onClick={() => onPageChange(pageNumberText)}>{pageNumberText}</SoftPagination>;
                })
            }
            <SoftPagination item key={'pagination_next'} onClick={() => (currentPage != maxPages) ? onPageChange(currentPage + 1) : {}} disabled={currentPage === maxPages ?? false}>
                <Icon>keyboard_arrow_right</Icon>
            </SoftPagination>
        </SoftPagination>
    </SoftBox>;
}
Pagination.defaultProps = {
    maxPages: 1,
    currentPage: 1,
    onPageChange: () => { }
};
Pagination.propTypes = {
    maxPages: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired
};

const MINIMAL_PAGE_ITEM_COUNT = 7;
function generatePageItems(total, current) {
    const width = 7;
    if (total < width) {
      return [...new Array(total).keys()];
    }
    const left = Math.max(0, Math.min(total - width, current - Math.floor(width / 2)));
    const items = new Array(width);
    for (let i = 0; i < width; i++) {
      items[i] = i + left;
    }
    if (items[0] > 0) {
      items[0] = 0;
      items[1] = 'prev-more';
    }
    if (items[items.length - 1] < total - 1) {
      items[items.length - 1] = total - 1;
      items[items.length - 2] = 'next-more';
    }
    return items;
  }
export default Pagination;